import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const StyledText = styled.p`
    ${setFontVariant("listItem1")};

    margin: 0;
`;
